/**
 * Sentry DSN Key
 */
export const SENTRY_DSN = process.env.SENTRY_DSN_FRONTEND
